<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast />
                <h5>{{ $t('menu.ssbtTransactions') }}</h5>
                <div class="p-grid">
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Calendar ref="startDateCalendar" style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="startDateModel"></Calendar>
                            <label>{{ $t('sportsbets.startDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="shopsModel" :options="shops" optionLabel="name" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.shop') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2"></div>
                    <div class="p-col-6 p-md-5 p-text-right"><Button type="button" :loading="isReportLoading" :label="$t('buttons.show')" class="p-button-raised p-button-success" @click="showReport()" /></div>
                    <div v-show="showReport" class="p-col-6 p-md-1 p-text-right">
                        <Button type="button" :label="$t('buttons.saveXls')" :loading="isReportDownloading" icon="pi pi-download" class="p-button-raised p-button-info" @click="saveXls()" />
                    </div>
                    <transition-group name="p-message" tag="div" class="p-col-12">
                        <Message :key="errorKeyCount" :severity="'error'" v-show="showError">{{ $t('alerts.generalError') }}</Message>
                    </transition-group>
                </div>
                <div class="card" v-if="showReportData">
                    <DataTable :value="reportData" ref="datatable" responsiveLayout="scroll">
                        <Column>
                            <template #body="slotProps">
                                <span class="indexColumn">{{ slotProps.index + 1 }}</span>
                            </template>
                        </Column>
                        <Column :header="$t('system.shop')" field="ShopId" :sortable="true">
                            <template #body="slotProps"> {{ shopsDictionary[slotProps.data.ShopId] }}</template></Column
                        >
                        <Column field="Time" :header="$t('sportsbets.date')" :sortable="true">
                            <template #body="slotProps">{{ formatCSDateAndTime(slotProps.data.Time) }} </template>
                        </Column>
                        <Column field="Amount" :header="$t('bets.amount')" :sortable="true">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.Amount) }} </template>
                        </Column>
                        <Column :header="$t('transactions.details')" field="Comments"> </Column>
                        <Column :header="$t('system.terminal')" field="TerminalId" :sortable="true"> </Column>
                        <Column :header="$t('bets.ticketSerial')" field="TicketSerial" :sortable="true"> </Column>
                        <Column :header="$t('transactions.userId')" field="UserId" :sortable="true"> </Column>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BoReportsApi } from '../../../service/BoReportsApi';
import { BoApi } from '../../../service/BoApi';
import { BoSaveReportsApi } from '../../../service/BoSaveReportsApi';
export default {
    name: 'report',
    data() {
        return {
            reportData: [],
            BoApi: new BoApi(),
            BoReportsApi: new BoReportsApi(),
            BoSaveReportsApi: new BoSaveReportsApi(),
            isReportLoading: false,
            isReportDownloading: false,
            showReportData: false,
            startDateModel: null,
            errorKeyCount: 0,
            showError: false,
            shops: [],
            shopsModel: { name: 'All', _id: 'all' },
            crtRoute: 'ssbtTransactions',
            shopsDictionary: [],
        };
    },
    mounted() {
        this.getShops();
        let crtDate = new Date();
        let year = crtDate.getFullYear();
        let month = crtDate.getMonth() + 1;
        if (month <= 9) {
            month = '0' + month;
        }
        let day = crtDate.getDate();
        if (day <= 9) {
            day = '0' + day;
        }
        var startDateString = year + '-' + month + '-' + day + 'T00:00';
        this.startDateModel = new Date(startDateString);
        this.showReport();
    },
    computed: {
        editPage() {
            return this.crtRoute + '/add';
        },
        availableMenus() {
            return this.$store.getters['user/availableMenus'];
        },
    },
    watch: {
        shopsModel() {
            if (!this.notNullOrEmptyObject(this.shopsModel)) {
                this.shopsModel = { name: 'All', _id: 'all' };
            }
            // this.showReport();
        },
    },
    methods: {
        getShops() {
            this.BoApi.getShops('')
                .then(shopsResponse => {
                    let shopsDdlValues = [];
                    for (var i = 0; i < shopsResponse.data.length; i++) {
                        let shopItem = {
                            name: shopsResponse.data[i].code + ' - ' + shopsResponse.data[i].name,
                            code: shopsResponse.data[i].code,
                            _id: shopsResponse.data[i]._id,
                        };
                        shopsDdlValues.push(shopItem);
                    }
                    this.shops = shopsDdlValues;
                    this.addShops = shopsDdlValues;
                    this.createShopsDictionary();
                    this.shops.unshift(this.shopsModel);
                })
                .catch(error => {
                    this.checkForUnauthorizedError(error);
                });
        },
        showReport() {
            this.showReportData = false;
            this.isReportLoading = true;
            this.BoReportsApi.getSsbtTransactions(this.shopsModel._id, this.formatEnDateAndTime(this.startDateModel))
                .then(reportResponse => {
                    if (reportResponse.data != null) {
                        this.reportData = reportResponse.data;
                        this.tableKey++;
                    }
                    this.isReportLoading = false;
                    this.showReportData = true;
                })
                .catch(error => {
                    this.checkForUnauthorizedError(error);
                    this.showError = true;
                    this.errorKeyCount++;
                    this.isReportLoading = false;
                });
        },
        saveXls() {
            this.isReportDownloading = true;
            this.BoSaveReportsApi.saveSsbtTransactions(this.shopsModel._id, this.formatEnDateAndTime(this.startDateModel))
                .then(response => {
                    this.isReportDownloading = false;
                    let blob = new Blob([response.data], { type: 'application/xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'SsbtTransactions' + this.formatEnDateAndTime(this.startDateModel) + '.xlsx';
                    link.click();
                })
                .catch(error => {
                    this.checkForUnauthorizedError(error);
                    this.showError = true;
                    this.errorKeyCount++;
                    this.isReportDownloading = false;
                });
        },
        showToast(toastSeverity, text) {
            this.$toast.add({ severity: toastSeverity, summary: '', detail: text, life: this.getToastLifeSeconds() });
        },
        createShopsDictionary() {
            for (let i = 0; i < this.shops.length; i++) {
                this.shopsDictionary[this.shops[i]._id] = this.shops[i].code + ' - ' + this.shops[i].name;
            }
        },
    },
};
</script>
